import { logoFlipFlop } from "assets";
import { Popover, PopoverContent, PopoverTrigger } from "components/app/popover/Popover";

interface SubChatHeaderProps {
  index: number;
  setOpenPopoverIndex: (value: number | null) => void;
  openPopoverIndex: number | null;
}

export default function SubChatHeader({ index, setOpenPopoverIndex, openPopoverIndex }: SubChatHeaderProps) {
  return (
    <div key={index}>
      <Popover
        open={openPopoverIndex === index}
        onOpenChange={(isOpen) => {
          setOpenPopoverIndex(isOpen ? index : null);
        }}
      >
        <PopoverTrigger asChild>
          <div className="flex items-center gap-3 p-3 rounded-lg cursor-pointer">
            <img src={logoFlipFlop} alt="profile" className="w-10 h-10 rounded-full" />
            <div className="flex flex-col flex-1">
              <h3 className="font-semibold">name</h3>
              <p className="truncate text-gray-400">message</p>
            </div>
            <span className="text-sm ">{index + 1}</span>
          </div>
        </PopoverTrigger>

        <PopoverContent isShowBtnXClose={true} side="left" align="center" sideOffset={10} className="w-96 cursor-pointer me-3">
          <span className="text-sm ">{index + 1}</span>
          <div>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque soluta aspernatur commodi alias magni iste id voluptas unde quidem quam quisquam natus eveniet adipisci
            fuga nulla voluptatem explicabo perferendis, dolore mollitia facere. Officiis eum pariatur sed veniam nihil asperiores culpa dolores sapiente voluptatibus nisi nulla
            distinctio officia numquam, eaque, quibusdam optio reiciendis eius minima nemo totam? Repudiandae facilis illum qui nulla! Beatae sunt quae voluptas itaque, recusandae
            impedit velit eveniet rem nostrum molestias eum dolorem consequatur praesentium modi tenetur perspiciatis tempore voluptatum fugit pariatur, facere nihil laboriosam,
            ipsa nam. Sed nobis blanditiis nihil architecto quam rerum laudantium reprehenderit maxime non!
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
